// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3A2l5","content":"styles_content__3qx_H"};